import { query, collection, orderBy, getDocs, getFirestore, where } from "firebase/firestore";
import employeeConverter from "../converters/employeeConverter";
import { Employee } from "../types/Employee";

export const queryEmployees = async (idNumber?: string) => {
  const db = getFirestore();
  const q = idNumber 
    ? query(collection(db, 'Employees'), where('idNumber', '>=', idNumber), where('idNumber', '<=', idNumber + '\uf8ff'), where('status', '==', 'Active')).withConverter(employeeConverter)
    : query(collection(db, 'Employees'), where('status', '==', 'Active'), orderBy('idNumber', 'asc')).withConverter(employeeConverter);
  return await getDocs(q).then((qSnapshot) => qSnapshot.docs.map((d) => d.data()));
};

export const querySupervisors = async () => {
  const db = getFirestore();
  const q = query(collection(db, 'Employees'), where('type', '==', 1), where('status', '==', 'Active'), orderBy('idNumber', 'asc')).withConverter(employeeConverter);
  return await getDocs(q).then((qSnapshot) => qSnapshot.docs.map((d) => d.data()));
};

export const queryChiefSupervisors = async () => {
  const db = getFirestore();
  const q = query(collection(db, 'Employees'), where('type', '==', 0), where('status', '==', 'Active'), orderBy('idNumber', 'asc')).withConverter(employeeConverter);
  return await getDocs(q).then((qSnapshot) => qSnapshot.docs.map((d) => d.data()));
};